/*
  Equishop: sledzenie klikniec w numery telefonow (2026-10-09)
  - kazde klikniecie w link tel: wysyla zdarzenie do Ahrefs Web Analytics
    (window.AhrefsAnalytics.sendEvent) oraz do dataLayer (Google Tag Manager)
  - nazwa zdarzenia: "klik_telefon"; w podgladzie motywu i w edytorze: "klik_telefon_test"
    (testy nie mieszaja sie z prawdziwymi danymi)
  - wlasciwosci: osoba, sekcja, numer, szablon, jezyk
  - osoba: wg listy NUMERY ponizej, a dla nowych numerow imie z karty
    (sekcja "Saddlefitting - eksperci" i pasek "Dzial siodel")
  - nowa osoba z innym numerem zostanie rozpoznana z karty; zeby nazwa byla
    stala w raportach, dopisz jej numer do listy NUMERY
*/
(function () {
  if (window.__eqTelefonyAhrefs) return;
  window.__eqTelefonyAhrefs = true;

  var NUMERY = {
    '508422339': 'Katarzyna Czaprańska',
    '735025024': 'Mateusz Cybulski',
    '728826517': 'Aleksandra Zaborowska',
    '603272767': 'Piotr Wierzchowski',
    '514766505': 'Monika Zastrzeżyńska-Rychwalska',
    '327824568': 'Equishop (numer ogólny)'
  };

  function txt(el) {
    return el ? String(el.textContent || '').replace(/‑/g, '-').replace(/\s+/g, ' ').trim() : '';
  }

  function cyfry(href) {
    var d = String(href || '').replace(/^tel:/i, '').replace(/\D/g, '');
    if (d.length === 13 && d.indexOf('0048') === 0) d = d.slice(4);
    if (d.length === 11 && d.indexOf('48') === 0) d = d.slice(2);
    return d;
  }

  function kontekst(a) {
    var sec = a.closest('section');
    var cls = sec ? String(sec.getAttribute('class') || '') : '';
    var card = a.closest('.sfe-card');
    if (card || /(^|\s)sfe-/.test(cls)) {
      var nm = card ? card.querySelector('.sfe-card-name') : null;
      var osoba = '';
      if (nm) {
        osoba = (txt(nm.querySelector('strong')) + ' ' + txt(nm.querySelector('em'))).trim() || txt(nm);
      }
      return { osoba: osoba, sekcja: 'saddlefitting_eksperci' };
    }
    if (/(^|\s)zsq-/.test(cls)) {
      return { osoba: txt(sec.querySelector('.zsq-name')), sekcja: 'dzial_siodel' };
    }
    if (a.closest('footer, .footer, [id*="footer"]')) return { osoba: '', sekcja: 'stopka' };
    if (a.closest('header, .header, [id*="header"]')) return { osoba: '', sekcja: 'naglowek' };
    var w = a.closest('[id^="shopify-section-"]');
    var id = w ? w.id.replace(/^shopify-section-/, '').replace(/^(template|sections)--\d+__/, '') : '';
    // losowy dopisek Shopify (np. eq_hero_amYPyk -> eq_hero), zeby ta sama sekcja na roznych stronach miala jedna nazwe
    id = id.replace(/_([A-Za-z0-9]{6})$/, function (m, s) { return /[A-Z0-9]/.test(s) ? '' : m; });
    return { osoba: '', sekcja: id || 'inne' };
  }

  function czyTest() {
    var S = window.Shopify || {};
    if (S.designMode) return true;
    if (S.theme && S.theme.role && S.theme.role !== 'main') return true;
    return false;
  }

  function doAhrefs(nazwa, props, proba) {
    var A = window.AhrefsAnalytics;
    if (A && typeof A.sendEvent === 'function') {
      try { A.sendEvent(nazwa, { props: props }); } catch (err) {}
      return;
    }
    if (proba < 10) {
      setTimeout(function () { doAhrefs(nazwa, props, proba + 1); }, 300);
    }
  }

  var ostatni = { el: null, t: 0 };

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    var a = t && t.closest ? t.closest('a[href^="tel:" i]') : null;
    if (!a) return;

    var teraz = Date.now();
    if (ostatni.el === a && teraz - ostatni.t < 1500) return;
    ostatni.el = a;
    ostatni.t = teraz;

    var nr = cyfry(a.getAttribute('href'));
    var k = kontekst(a);
    var props = {
      osoba: NUMERY[nr] || k.osoba || 'inny',
      sekcja: k.sekcja || 'inne',
      numer: nr,
      szablon: (document.body && document.body.getAttribute('data-tpl')) || '',
      jezyk: String(document.documentElement.lang || '').slice(0, 2).toLowerCase()
    };
    var nazwa = czyTest() ? 'klik_telefon_test' : 'klik_telefon';

    doAhrefs(nazwa, props, 0);

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: nazwa,
        eq_osoba: props.osoba,
        eq_sekcja: props.sekcja,
        eq_numer: props.numer,
        eq_szablon: props.szablon
      });
    } catch (err) {}
  }, true);
})();
